import React from 'react';

const StudentActivities = () => {
  return (
    <div className="sessions-page">
      <div className="sessions-header sessions-header--expanded">
        <div className="sessions-header__content">
          <h1 style={{ margin: 0 }}>Activities</h1>
        </div>
      </div>
      <div className="detail-empty" style={{ padding: '1.25rem 1rem 2rem' }}>
        <div className="empty-card">
          <div className="title">Activities Coming Soon</div>
          <div className="subtitle">This tab will host student practice activities and progress tracking.</div>
        </div>
      </div>
    </div>
  );
};

export default StudentActivities;

